"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./Input.module.css"));
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var Input = (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Input.prototype.handleChange = function (evt) {
        this.value = evt.target.validity.valid ? evt.target.value : this.value;
    };
    Input.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, type = _a.type, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, pattern = _a.pattern, mask = _a.mask;
        this.value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
            if (error.includes("Ssn")) {
                var regex = /Ssn/gi;
                error = error.replace(regex, "SSN");
            }
        }
        return (React.createElement("div", null,
            React.createElement(react_input_mask_1.default, { className: css, id: id, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: type, disabled: disabled, onInput: this.handleChange.bind(this), value: this.value, pattern: pattern, placeholder: placeholder, mask: mask, maskChar: "" }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    Input.defaultProps = {
        type: "text",
        errors: {}
    };
    return Input;
}(react_1.Component));
exports.Input = Input;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0lucHV0L0lucHV0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQix5REFBNEM7QUFDNUMsc0VBQXdDO0FBY3hDO0lBQTJCLHlCQUFvQjtJQUEvQzs7SUF5REEsQ0FBQztJQWxERyw0QkFBWSxHQUFaLFVBQWEsR0FBRztRQUNaLElBQUksQ0FBQyxLQUFLLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQTtJQUMxRSxDQUFDO0lBRU0sc0JBQU0sR0FBYjtRQUNVLElBQUEsZUFVUSxFQVRWLFVBQUUsRUFDRix3QkFBUyxFQUNULHNCQUFRLEVBQ1IsY0FBSSxFQUNKLDRCQUFXLEVBQ1gsc0JBQVEsRUFDUixrQkFBTSxFQUNOLG9CQUFPLEVBQ1AsY0FDVSxDQUFBO1FBQ2QsSUFBSSxDQUFDLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQ2hDLElBQUksS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV0QixJQUFJLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBO1FBQ3JCLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1lBRWxDLElBQUksS0FBSyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsRUFBRTtnQkFDdkIsSUFBTSxLQUFLLEdBQUcsT0FBTyxDQUFBO2dCQUNyQixLQUFLLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUE7YUFDdEM7U0FDSjtRQUVELE9BQU8sQ0FDSDtZQUNJLG9CQUFDLDBCQUFTLElBQ04sU0FBUyxFQUFFLEdBQUcsRUFDZCxFQUFFLEVBQUUsRUFBRSxFQUNOLFFBQVEsRUFBRSxVQUFDLEtBQUs7b0JBQ1osUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO2dCQUNwQyxDQUFDLEVBQ0QsSUFBSSxFQUFFLElBQUksRUFDVixRQUFRLEVBQUUsUUFBUSxFQUNsQixPQUFPLEVBQUUsSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQ3JDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxFQUNqQixPQUFPLEVBQUUsT0FBTyxFQUNoQixXQUFXLEVBQUUsV0FBVyxFQUN4QixJQUFJLEVBQUUsSUFBSSxFQUNWLFFBQVEsRUFBQyxFQUFFLEdBQ2I7WUFDRCxLQUFLLElBQUksMkJBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU0sQ0FDaEQsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQXREYSxrQkFBWSxHQUFHO1FBQ3pCLElBQUksRUFBRSxNQUFNO1FBQ1osTUFBTSxFQUFFLEVBQUU7S0FDYixDQUFBO0lBb0RMLFlBQUM7Q0FBQSxBQXpERCxDQUEyQixpQkFBUyxHQXlEbkM7QUF6RFksc0JBQUsifQ==